import React, {useState} from 'react';


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import he from 'date-fns/locale/he';
import {connect} from "react-redux";



const CustomDatePicker = (props) =>{

    const user = props.userData;


    registerLocale('he',he);
    setDefaultLocale('he');

    //if user has set birthday than it shows it as default
    let getUsersBDay = () =>{
        let date = '00/00/0000';
        if (user){
            date = parseInt(user.birthday) !== 0 ? new Date(parseInt(user.birthday * 1000)) : '00/00/0000';
        }
        return date;
    };

    const date = getUsersBDay();

    const [startDate, setStartDate] = useState(date);



    return(
        <div className={'date-picker ' + props.className}>
            <DatePicker local='he'
                        useWeekdaysShort={true}
                        selected={(typeof startDate === 'string' ? null : startDate)}
                        onChange={date => {setStartDate(date); props.onChange(date)}}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={85}
                        maxDate={new Date().setFullYear(new Date().getFullYear()-18)}
                        placeholderText={startDate}
                        dateFormat={"dd/MM/yyyy"}
            />
        </div>
    );

};


const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        userData: store.config.UserData,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(CustomDatePicker);